// extracted by mini-css-extract-plugin
export default {"itemsHeaderRow":"styles_itemsHeaderRow__+Yacu","table":"styles_table__gXLGq","tableContainer":"styles_tableContainer__M6Z0+"};